import { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../apiStore'
import { Link,useNavigate } from 'react-router-dom';
import {encryptedPayload, decryptPayload,encryptQuery } from "app/utils/JwtEncription";
import { getRoleFromToken } from "app/utils/decodeJwtRole";
import Swal from 'sweetalert2';


// const token = localStorage.getItem("Ankit")


const api_url = config.api_urls
const jwtKey = config.jwtKey


export const GetDataAPi = async (url) => {
  const token = localStorage.getItem("Ankit")
  let a = url.slice(1, 100);
 
  
  const encrtUrl = jwtKey == 'true'? await encryptQuery(a) : a;
  const urls =  api_url+"/"+encrtUrl;      
  const headers = {
    'authorization': `Bearer ${token}`,
     'Content-Type': 'application/json'
  };



  const requestOptions = {
    method: "GET",
    headers: headers,
    // body: JSON.stringify(data)
  };
  try {
    // console.log(urls);
    
    const respons = await fetch(urls, requestOptions);
    
    
    const data = await respons.json();
    
     
    const res = jwtKey == 'true'? await decryptPayload(data) : data;
    // console.log(urls,"resong",respons,data,res);
       
    if (!respons.status) {
      throw new Error('Network response was not ok');
    }
    return res;
  } catch (error) {
    
     console.log("error for post api",error);
     return error;
  }
}; 


export const GetDataAPiCsv = async (url) => {
  const token = localStorage.getItem("Ankit")
  let a = url.slice(1, 100);
  const encrtUrl = jwtKey == 'true'? await encryptQuery(a) : a;
  const urls =  api_url+"/"+encrtUrl;      
  const headers = {
    'authorization': `Bearer ${token}`,
     'Content-Type': 'application/json'
  };



  const requestOptions = {
    method: "GET",
    headers: headers,
    // body: JSON.stringify(data)
  };
  try {
    const respons = await fetch(urls, requestOptions);
    // const data = await respons.json();
    
     
    // const res = jwtKey == 'true'? await decryptPayload(data) : data;
    
       
    if (!respons.status) {
      throw new Error('Network response was not ok');
    }
    return await respons.text();
  } catch (error) {
    
     console.log("error for post api",error);
     return error;
  }
}; 

 export const validForm = (passData) => {
  for (let a in passData) {
   if (passData[a] === "") {
     
    //  alert(`in this form "key is empty ${a}",${passData[a]} `);
     return false;
   }
   
 }

 return true;
};


export const PostApi = async (url,data,VarifyKey=true) => {
  const token = localStorage.getItem("Ankit")
  //  const newONe = await CheckToken()

  if(VarifyKey){
  const newONe = await Raitwar()
     
  if(!newONe){
   Swal.fire({
  title: 'Session Expired',
  text: 'Please login again to continue.',
  icon: 'warning',
  confirmButtonText: 'OK'
}).then(() => {
  window.location.href = '/'; // or '/'
});
    return;
  }

}

  let a = url.slice(1, 100);
  const encrtUrl = jwtKey == 'true'? await encryptQuery(a) : a;
  const urls =  api_url+"/"+encrtUrl;
  const encryptedData = jwtKey == 'true' ? await encryptedPayload(data) : data;
  const headers = {
    'authorization': `Bearer ${token}`,
     'Content-Type': 'application/json'
  };
  const requestOptions = {
    method: "POST",
    headers: headers,
    body: JSON.stringify(encryptedData)
  };
  try {
    const respons = await fetch(urls, requestOptions);
    
    return respons;
  } catch (error) {
     console.log("error for post api",error);
     console.log(error);
    return error;
  }
}; 



export const DeleteApi = async (url) => {
 
  const token = localStorage.getItem("Ankit")
   let a = url.slice(1, 100);

  const encrtUrl = jwtKey == 'true'? await encryptQuery(a) : a;
  const urls =  api_url+"/"+encrtUrl;
  const headers = {
    'authorization': `Bearer ${token}`,
     'Content-Type': 'application/json'
  };
  const requestOptions = {
    method: "DELETE",
    headers: headers,
    
  };
  try {
    const respons = await fetch(urls, requestOptions);
  
     return respons;
  } catch (error) {
     console.log("error for post api",error);
     return error;
  }
}; 


export const ImagrUpload = async(fd)=>{
  const token = localStorage.getItem("Ankit")
  
  const headers = {
    'authorization': `Bearer ${token}`,
    //  'Content-Type': 'application/json'
  };
  
  try {
     const encrtUrl = jwtKey == 'true'? await encryptQuery("file-upload") : "file-upload";
  
  
      const data = await fetch(`${api_url}/${encrtUrl}`, {
        method: 'POST',
        headers: headers,
        body: fd
      })    
        const r = await data.json()
      if(data.status !== 200){
     
        return r
      }
    
      const decryptedData = jwtKey == 'true'?  await decryptPayload(r) : r;
    
      
     const imgdatas = decryptedData[0].filename
     return imgdatas;
    
  } catch (error) {
      console.log("img upload api error",error);
      return error;
  }
}

export const MultiImgUpload = async(fd)=>{
  const token = localStorage.getItem("Ankit")
  
  const headers = {
    'authorization': `Bearer ${token}`,
    //  'Content-Type': 'application/json'
  };
  
  try {
   const encrtUrl = jwtKey == 'true'? await encryptQuery("file-upload") : "file-upload";
   
      const data = await fetch(`${api_url}/${encrtUrl}`, {
        method: 'POST',
        headers: headers,
        body: fd
      })  
    
      const r = await data.json()
      const rr = jwtKey == 'true'?  await decryptPayload(r) : r;
      const imgdatas = rr?.map((e)=>{
        return e.filename
      }
           
      )
     return imgdatas;
    
  } catch (error) {
      console.log("img upload api error",error);
      return error;
  }
}


export const ActiveAPi = async (url,data) => {
  const token = localStorage.getItem("Ankit")

  const newONe = await Raitwar()
     
  if(!newONe){
   Swal.fire({
  title: 'Session Expired',
  text: 'Please login again to continue.',
  icon: 'warning',
  confirmButtonText: 'OK'
}).then(() => {
  window.location.href = '/'; // or '/'
});
    return;
  }


  let a = url.slice(1, 100);
  const encrtUrl = jwtKey == 'true'? await encryptQuery(a) : a;
  const urls =  api_url+"/"+encrtUrl;
  const headers = {
    'authorization': `Bearer ${token}`,
     'Content-Type': 'application/json'
  };
  const requestOptions = {
    method: "PATCH",
    headers: headers,
    body: JSON.stringify(data) || data
  };
  try {
    const respons = await fetch(urls, requestOptions);
       
    if (!respons.status === 201) {
      throw new Error('Network response was not ok');
    }
   const r = await respons.json()
   const res = jwtKey == 'true'? await decryptPayload(r) : r;

    return res;
  } catch (error) {
     console.log("error for post api",error);
     return error;
  }
}; 

export const UpdateApi = async (url,data) => {
  const token = localStorage.getItem("Ankit")
   
    // const navigate = useNavigate()
      const newONe = await Raitwar()
     
  if(!newONe){
   Swal.fire({
  title: 'Session Expired',
  text: 'Please login again to continue.',
  icon: 'warning',
  confirmButtonText: 'OK'
}).then(() => {
  window.location.href = '/'; // or '/'
});
    return;
  }


   let a = url.slice(1, 100);
  const encrtUrl = jwtKey == 'true'? await encryptQuery(a) : a;
  const urls =  api_url+"/"+encrtUrl;
  let encryptedData = jwtKey == 'true' ? await encryptedPayload(data) : data;
  if(!data){
    encryptedData = null  }
  const headers = {
    'authorization': `Bearer ${token}`,
     'Content-Type': 'application/json'
  };
 
  
  const requestOptions = {
    method: "PATCH",
    headers: headers,
    body: JSON.stringify(encryptedData)
  };
  try {
  
    const respons = await fetch(urls, requestOptions);
       
    if (!respons.status) {
      throw new Error('Network response was not ok');
    }
  //  const r = await respons.json()
  //  const res = jwtKey == 'true'? await decryptPayload(respons) : respons;
   

    return respons;
  } catch (error) {
     console.log("error for Update api",error);
    //  if(error.include('Invalid Token')){
    //   console.log("kal login me naviget kar dunga");
      
    //  }
     return error;
  }
}; 






export const ListChangeApi = async (url, data) => {
  const token = localStorage.getItem("Ankit")
  let a = url.slice(1, 100);
  const encrtUrl = jwtKey == 'true'? await encryptQuery(a) : a;
  const urls =  api_url+"/"+encrtUrl;

  const headers = {
    'authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  // const string = JSON.stringify(data);
  // console.log("Stringified data:", string);
  // console.log("Parsed data:", JSON.parse(string));

  const requestOptions = {
    // method: "PUT",
    headers: headers,
    // body: string, // use the already stringified data
  };

  try {
    const respons = await axios.patch(urls, data, requestOptions);
   
    // console.log(data);
    // if (!respons.ok) { // checking for a successful response
    //   throw new Error('Network response was not ok');
    // }

    // const ;
    const res = jwtKey == 'true' ? await decryptPayload(respons.data) : respons.data; 

    return res;
  } catch (error) {
    console.log("Error in API call:", error);
    return error;
  }
};

const Raitwar = async () => {

  const token = localStorage.getItem("Ankit")
 

  const headers = {
    authorization: `Bearer ${token}`,
  };
  try {
    // Role comes off the JWT's own `type` claim now -- see decodeJwtRole.js.
    const isAdmin = getRoleFromToken(token) === "Admin";
   const urlPoint = isAdmin
  ? jwtKey == 'true'? await encryptQuery("admin/verifyToken") : "admin/verifyToken"
  : jwtKey == 'true'? await encryptQuery("vendor-profile/verifyToken") : "vendor-profile/verifyToken"
  let newUrl = `${api_url}/${urlPoint}`

const response = await axios.post(newUrl, {}, {
  headers: headers,
});
    if (response.status === 200) {
      return true;
    } else {
      return false
    }
  } catch (error) {
     return false
    console.log("authotications", error);
  }
}; 

export const CheckToken = async () => {
  const token = localStorage.getItem("Ankit")
  const navigate = useNavigate()

  const headers = {
    authorization: `Bearer ${token}`,
  };
  try {
    // Role comes off the JWT's own `type` claim now -- see decodeJwtRole.js.
    const isAdmin = getRoleFromToken(token) === "Admin";
   const urlPoint = isAdmin
  ? jwtKey == 'true'? await encryptQuery("admin/verifyToken") : "admin/verifyToken"
  : jwtKey == 'true'? await encryptQuery("vendor-profile/verifyToken") : "vendor-profile/verifyToken"
  let newUrl = `${api_url}/${urlPoint}`

const response = await axios.post(newUrl, {}, {
  headers: headers,
});
    if (response.status === 200) {
      return true;
    } else {
      navigate('/')
    }
  } catch (error) {
    navigate('/')
    console.log("authotications", error);
  }
}; 